import UserRow from "./UserRow";
import EmptyState from "../UI/EmptyState";

const UsersTable = ({ users, search }) => {
  if (!users || users.length === 0) {
    return (
      <EmptyState
        icon={
          search ? "mdi:magnify-remove-outline" : "mdi:account-group-outline"
        }
        title={
          search ? "No se encontraron usuarios" : "No hay usuarios para mostrar"
        }
        description={search ? "Intenta con otra búsqueda" : null}
      />
    );
  }

  return (
    <div className="table-responsive scroll-sm">
      <table className="table bordered-table mb-0">
        <thead>
          <tr>
            <th scope="col">Nombre </th>
            <th scope="col">Escuela</th>
            <th scope="col">Plantel</th>
            <th scope="col">Estatus</th>
            <th scope="col">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <UserRow key={user.id} user={user} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UsersTable;
